import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import Swal from 'sweetalert2'
import mainMixins from './mainMixins.js'
import { i18n } from '@/plugins/i18n'

Vue.config.productionTip = false

Vue.mixin(mainMixins)

window.axios = axios
window.apiETC = 'https://sistema.etciberoamerica.com/'
// window.apiETC = 'http://apietc.loc/'
window.router = router
window.Fire = new Vue()
window.Swal = Swal
window.clientAPI = {
  'Content-Type': 'application/json',
  Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiYzA4YjY5ODc3ZTVlOTVkMGM4YjM0NWE3YTE0ZGVhODdmOTE0Yzc3NzZkZTMwNDI0NDgzYmE5MDNiNjZkM2NhOTE5YTUwYzVkNzFkNWYwMTUiLCJpYXQiOjE3Nzg1MTAwMjcuODkwOTk5LCJuYmYiOjE3Nzg1MTAwMjcuODkxMDAxLCJleHAiOjE4MTAwNDYwMjcuODg4NTIsInN1YiI6IjEiLCJzY29wZXMiOltdfQ.CLUBVBfgP4odILrTcy6UV0cYdbVqoh7ZlNu9n8a8GUVHPq9s5a3IT4FftDJTpGAN0rRisESETTumYtzu6bLqiApiIpnNTHYUkyGsiIeYHV1whMTq6Ph58K-aGQcBa1BJ9dZwnO8ZAu3yK55C466kE3CjIzPA2fUaIEKpe5PL786jTyDbiwM9n4xoe6E5O5eHzczpD3kmMmvMVBlPiYd4L8Kv_2TWhmWBVi_758xWDG-MObSiAwk50H6SBJQFt584FerwoTt1CaDpKHLRsMtIO2u8JirPBHpnxDH6fWiDqhz8bqAB2o46aHOhuP4mq5k1f8LACtFoUbuE-wveBtEqjkxvTmmAcm48V0P6BQXH9Q9O_uVWoZ4G1zsGD_sb9HvBHdpsrcV85QZHm8SgRGFIYoX2aMJsDZdyZgjUOMj86Wvr9JsCrxj3v2L_kqWqYyM1t5a_eC_lLYclw8xr84C0ASIRiQsOXE4urEhPCIF3Si5_TRujEAt6Q9bAWqt58kx4zS96sPTfTnIp7_Bag_gu4gQ9FpmhE8nwb3o-MaYYnuz_loRos9dME3q_Chz89hAT5o5nR7yF8VuZQaU6pW7VpNH4k2N1y-VKLS84o8VvN8OY40H-uzWwhLBarDb-iupoffnrZ6-vN-kcRwZK_16lzg4rKn36PiJagtiGFNzvqBA'
  // Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiOWU0MWM5ZWE5OGZjMzY4ODk5ZDBjYzViNWExMjg2MDM4NDZlNTZkNzc3M2Q2ZGU1OGRhYmNhZWM5Y2IxNmZiYWIzMzgyOWU4MDJlODViMWYiLCJpYXQiOjE3MTgxOTY3ODYuODI0MTQyLCJuYmYiOjE3MTgxOTY3ODYuODI0MTQ1LCJleHAiOjE3NDk3MzI3ODYuODE2MTU5LCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.iect33VpEFVBXxRsoy68rbfTEbazS_sxBwQFsfnM-PFiU0a8WttdlJl6SV1s-Al9wYZpWkzAUYgPbStG23jq5Hh7eHZ0Mew-B8eysgPMfden3OaKZPkOmwIwEBwZofgxbtPi7YrYMekZ7SRWKUs79C-yZTNw7CnEMTOJcrqFvL4KskOxtsxdsZlGL5psGeQb9a-RII7eU2ka7TrlodzyndNb2hLX3l6FkwU35h0iUgSE-yZfdCcQwCJ_oE-oO4UXJvo7WHqlRi-TwYTLeeXTPSrjktcvjfT-2M-qI4NLtHd6Le_oyH2om1T6CLYJBeXPGitTN9fvAUC0HObghIGcsMUdlh7eTz0iWBPRL5EdYpAiVvSP6a5TfTJzAN_Rx2XvdZ5VphYoP56C0HF4wopIHx1eGjvcewPQAhGDm74bUuTf0DuvnIXItsjdPSN2-3c0FQ69vhMU8gKnZ7iWWKZak7omXGWbvNWxOymU4OHpmGgTgDVLtUOYfyikeb5h3dwbYTLcWjW0jkRxspeIzGcLsqUQ7dqf1XhTLTDibETz821AE_pNt7RgLP2kjrS1Z34Aj3JxlfhntQQ7GLvxT0icWPRKShMwbsFQ_RlnpNTA5iSClykChrEPwffk4SL6axIUw4EXd738o3id9NhsfOjWLyQtoZJEPJK0g6DxwO-YIb8'
}

window.clientInternalAPI = {
  'Content-Type': 'application/json',
  Authorization: localStorage.tokenETC
}

window.hostname = location.hostname

Vue.config.ignoredElements = ['field','block','category','xml','mutation','value','sep']

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
